export default {
  LoanOfficerCard: {
    totalCost: 'Total 5 yrs. Cost',
    apr: 'APR',
    interestRate: 'Interest Rate',
    payment: 'Mon. Payment',
    away: 'Away',
    online: 'online',
    buyerSender: 'Me',
    outsideGuidelines: 'Based on your information, {{name}} was unable to send you a mortgage quote.',
  },
  LoanOfficerChatList: {
    nextStepsHeader: 'Unsure of next steps?',
    nextStepsTooltipHeader: 'Next Steps',
    nextStepsTooltip1: '1) Review your quote',
    nextStepsTooltip2: '2) Click Apply Now to complete your application',
    nextStepsTooltip3: "3) Buy the home of your dreams after you're approved!",
  },
  BuyerCard: {
    away: 'Away',
    online: 'online',
    autoFollowupsSwitch: 'Auto followups messages',
    autoFollowupsTooltip:
      'You can turn off auto-messaging for individual connections without disabling all auto-messaging.',
  },
  BuyersChatList: {
    all: 'All',
    favorites: 'Favorites',
    hidden: 'Hidden',
    tasks: 'Tasks',
    chatsPlaceholder: 'There are no chats in this list',
    chatsEnd: 'End of the chats list',
  },
  BuyerSteps: {
    header: 'Your Next Steps',
    firstStep: '1',
    firstStepLabel: 'Request Quotes',
    secondStep: '2',
    secondStepLabel: 'Ask Questions',
    thirdStep: '3',
    thirdStepLabel: 'Get Approved',
  },
  Chat: {
    inputFieldPlaceholder: 'Type your message here ....',
    sendMessageButtonText: 'Send Message',
    messagesPlaceholder: 'There are no messages yet',
    Messages: {
      Message: {
        BidMessage: {
          applyButton: 'Apply Now',
        },
      },
    },
  },
  LoanOfficerBar: {
    officersInfo: 'Profile Info',
    loanTerms: 'Quote Details',
    bidIsBlank: 'There are no bids from Loan Officer yet',
    LoanOfficerBlank: 'Choose loan officer to see information',
  },
  LoanOfficerInfo: {
    nmls: 'NMLS #',
    blankNmls: 'NMLS #--',
    nmlsWithCheckingServiceLink:
      '<p>NMLS #<a href="{{link}}" target="_blank" rel="noopener noreferrer">{{nmls}}</a></p>',
    aboutMe: 'About Me',
  },
  LoanTermsInfo: {
    totalCost: 'Total 5 yrs. Cost',
    apr: 'APR',
    interestRate: 'Interest Rate',
    monthlyPrInMiPayment: 'Principal, Interest and MI',
    monthlyTaxesInsurancePayment: 'Mortgage Taxes, Insurance Payment',
    monthlyTotalPayment: 'Total Mortgage Monthly Payment',
    originationCharges: 'Origination charges',
    applyButton: 'Apply Now',
  },
  VideoUpload: {
    sendVideoTitle: 'Send Video',
    sendVideoButtonText: 'Send Video',
    closeButtonText: 'Close',
    uploadVideoTitle: 'Upload Video',
    uploadVideoButtonText: 'Upload Video',
  },
  BuyerMessages: {
    MobileMessages: {
      selectLoanOfficer: 'Select Loan Officer',
      ChatPage: {
        LoanOfficerCard: {
          totalCost: 'Total 5 yrs. Cost',
          apr: 'APR',
          interestRate: 'Interest Rate',
          accept: 'Apply Now',
          callMe: 'Call Me',
          payment: 'Monthly Payment',
        },
      },
    },
    DesktopMessages: {
      selectChat: 'Select Loan Officer to chat with',
      bulkMessagingButton: 'Bulk Messaging',
      myMortgageInfo: 'My Mortgage Info',
    },
  },
  LoanOfficerMessages: {
    noChats: 'There are no chats yet',
    DesktopMessages: {
      noChatSelected: 'No chat selected',
    },
  },
  LoanOfficerControlPage: {
    borrowersInfo: "Borrower's info",
    loanOptions: 'Loan Options',
    noBidRequest: 'No bid request',
  },
  BidRequestInfo: {
    noBidRequest: 'There is no bid request',
  },
  BulkMessaging: {
    popupHeader: 'Bulk Messaging',
    message: 'Message',
    sendButton: 'Send Message',
    textPlaceholder: 'Start typing message here',
  },
  LoanOptions: {
    BidPage: {
      header: 'Your Mortgage Bid',
      AutoCalculation: {
        apr: '*APR',
        fiveYearsTotal: '*In Five Years Total',
        fiveYearsPrincipalPaid: '*In Five Years Principal',
        header: 'Auto Calculation',
        pi: 'Principal and Interest',
        mIrate: 'Annual Mortgage Insurance Rate',
        mi: 'Mortgage Insurance Payment',
        piMi: 'Principal, Interest, and MI',
        propertyTaxVal: 'Property Taxes',
        hazardInsuranceVal: 'Hazard Insurance',
        assessments: 'Assessments',
        estimatedTaxes: 'Taxes, Ins., & Asmts',
        estimatedTotalMonthlyPayment: 'Total Monthly Payment',
      },
      BidForm: {
        makeBidButton: 'Make Bid',
        updateBidButton: 'Update Bid',
        makeBidOutsideGuidelinesButton: 'Outside Guidelines',
        productSelection: 'Product Selection',
        interestRate: 'Interest Rate, %',
        upfrontCharges: 'Origination Charges',
        notes: 'Mortgage Bid Disclosure',
        selectOfferingPlacheholder: 'Select Offering',
        interestRatePlacheholder: '0.000',
        upfrontChargesPlacheholder: '0',
        makeBidRequestApprove: 'Are you sure that you want to send a bid?',
        makeBidRequestOutsideGuidelinesApprove: 'Confirm this request is outside of guidelines?',
        yesButtonText: 'Yes',
        noButtonText: 'No',
      },
    },
  },
  TodaysRates: {
    title: "Today's Mortgage Rate",
    videoTitle: 'Who We Are',
    button: 'Request a Custom Quote',
    buttonApply: 'Apply Now',
  },
  MortgageSurveyPage: {
    MobileMortgageSurveyPage: {
      header: 'My Mortgage',
    },
  },
  MortgageSurvey: {
    ControlBar: {
      nextButton: 'Next',
    },
    PriceTargetQuestion: {
      estimatedAnnualIncome: 'Recommended Annual Income',
      agressiveIncome: 'Aggressive',
      stretchedIncome: 'Stretched',
      suggestedIncome: 'Suggested',
    },
    DownPaymentTargetQuestion: {
      warning: 'Warning',
      lessWarning: `<p>Your mortgage down payment is less than 3%. Unless you are a veteran applying for a \
        <a href="https://www.benefits.va.gov/homeloans/" target="_blank">VA Home Loan</a>, many lenders will not have a mortgage \
        for you. Want a cool way to save for a down payment? We recommend <a href="https://digs.co/saver/" target="_blank">Digs Saver</a>.</p>`,
      moreWarning: "Target Down Payment can't be higher than home price",
    },
    AnnualGrossIncomeQuestion: {
      warning: 'Warning',
      warningText:
        'This salary is a little low for the home price you selected and may be outside the approval guidelines for some banks.',
    },
    MortgageBalanceQuestion: {
      warning: 'Warning',
      paidOffWarning:
        "That's great that you've paid off your mortgage. Next, you'll enter the amount of cash you want to take out.",
      higherWarning: 'Your mortgage balance is higher than the home value you selected.',
    },
    LocationQuestion: {
      placeholder: 'Start typing city...',
    },
  },
  BuyerDashboard: {
    WelcomePage: {
      header: 'The Simple Way to Find Your Mortgage',
      description: 'By the way, no cold calls.',
      button: 'Mortgage Rates ',
    },
    MyBundlePage: {
      DesktopMyBundlePage: {
        header: 'Your Personalized Quotes',
        mortgageRequest: 'Mortgage Request',
        startMessaging: 'Start Messaging',
      },
      MobileMyBundlePage: {
        header: 'Your Personalized Quotes',
        mortgageRequest: 'Mortgage Request',
      },
    },
  },
  BuyerRequestPage: {
    header: 'My Mortgage Info',
    retakeButton: 'Retake survey',
  },
  BidRequestCreatingProgress: {
    analyzing: 'Analyzing Your Request',
    matching: ' Matching Loan Officers',
    enteringAnonymous: 'Entering Chat Mode',
  },
  SteppedBuyerRegistrationForm: {
    button: 'Next',
    header: 'We never share your email address with anyone.',
    caption: 'Protected by TLS encryption',
    email: 'Email',
    password: 'Password',
    passwordConfirmation: 'Confirm Password',
  },
  BuyerRegistrationForm: {
    caption: 'Protected by TLS encryption',
    email: 'Email',
    password: 'Password',
    passwordConfirmation: 'Confirm Password',
    button: 'Next',
  },
  LoanOfficerRegistrationForm: {
    firstName: 'First Name',
    lastName: 'Last Name',
    nmls: 'NMLS Number',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    button: 'Sign Up',
  },
  RealEstateAgentRegistrationForm: {
    firstName: 'First Name',
    lastName: 'Last Name',
    mls: 'License #',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    button: 'Sign Up',
  },
  Login: {
    header: 'Log in to Bundle',
    or: 'or',
    label: 'Log In',
    forgotPassword: 'Forgot password?',
    signUp: 'Sign Up',
  },
  LoginForm: {
    button: 'Log in',
    email: 'Email',
    password: 'Password',
  },
  ForgotPassword: {
    header: 'Email Successfully Sent',
    didReceive: "Didn't receive the email?",
    tryAgain: 'Try again here',
    login: 'Log In',
  },
  ResetPassword: {
    login: 'Log In',
  },
  ResetPasswordForm: {
    header: 'Please enter new Password',
    button: 'Update Password',
    password: 'Password',
    passwordConfirmation: 'Confirm Password',
  },
  ForgotPasswordForm: {
    header: 'Please enter your Email',
    button: 'Send Recovery Email',
    email: 'Email',
  },
  SignUp: {
    createAnAccount: "Hey! I'm Jane. Let's get started.",
    signUpForBundle: 'Join Bundle',
    signUpBack: 'Back',
    BuyerRegistration: {
      header: 'We never share your email address.',
      or: 'or',
    },
  },
  Calculators: {
    RightBar: {
      header: 'More resources',
      assessment: 'Home Price Budget',
      monthlyBudget: 'Detailed Monthly Budget',
      decisions: '6 Home-Buying Decisions',
      freeQuotesButton: 'Mortgage Rates',
    },
    affordability: 'Home Price',
    monthlyPayment: 'Monthly Payment',
    compareRates: 'Mortgage Rates',
  },
  AffordabilityCalculator: {
    header: 'How Much House Can I Afford?',
    mortgageDetails: 'Details',
    annualIncome: 'Annual Income',
    carPayment: 'Car Payment',
    studentPayment: 'Student Loan Payment',
    cardPayment: 'Credit Card Payment',
    otherPayment: 'Other Loan Payments',
    debtToIncome: 'Debt to Income',
    mortgageInterestRate: 'Mortgage Interest Rate',
    mortgageTerm: 'Mortgage Term',
    propertyTaxRate: 'Property Tax Rate',
    mortgageInsurance: 'Mortgage Insurance Rate',
    mortgageInsuranceLabel: 'Mortgage Insurance Rate, %',
    propertyTaxRateLabel: 'Property Tax Rate, %',
    downPaymentPercent: 'Down Payment %',
    annualIncomeLabel: 'Annual Income, $',
    carPaymentLabel: 'Car Payment, $',
    studentPaymentLabel: 'Student Loan Payment, $',
    cardPaymentLabel: 'Credit Card Payment, $',
    otherPaymentLabel: 'Other Loan Payments, $',
    debtToIncomeLabel: 'Debt to Income, %',
    downPaymentPercentLabel: 'Down Payment %',
    mortgageInterestRateLabel: 'Mortgage Interest Rate, %',
    mortgageTermLabel: 'Mortgage Term, Years',
    DesktopCalculationsResult: {
      homeValue: 'Home price',
      downPayment: 'Down Payment',
      mortgagePayment: 'Mortgage Payment',
      totalDebtPayments: 'Loan Payments',
      debtToIncome: 'Debt to Income',
    },
    MobileCalculationsResult: {
      homeValue: 'Home price',
      downPayment: 'Down Payment',
      mortgagePayment: 'Mortgage Payment',
      totalDebtPayments: 'Loan Payments',
      debtToIncome: 'Debt to Income',
    },
  },
  MothlyPaymentCalculator: {
    header: 'Mortgage Payment Calculator',
    mortgageAmount: 'Mortgage Amount',
    mortgageAmountLabel: 'Mortgage Amount, $',
    interestRate: 'Interest Rate',
    interestRateLabel: 'Interest Rate, %',
    mortgageTerm: 'Mortgage Term',
    mortgageTermLabel: 'Mortgage Term, Years',
    DesktopCalculationsResult: {
      mortgagePayment: 'Monthly Payment',
    },
    MobileCalculationsResult: {
      mortgagePayment: 'Monthly Payment',
    },
  },
  AboutUs: {
    header: 'About Us',
    description: {
      firstSection: {
        title: 'What we believe',
        text:
          'We believe you want to make the right financial choices when you are shopping for a home. We also understand mortgages are confusing and you may not even know where to start. Our goal at Bundle is to give you a starting point, a place where you can ease into the mortgage process, comfortably and on your terms.',
      },
      secondSection: {
        title: 'What we do',
        text:
          'We created a simple process that allows you to take control of your mortgage. We give you the tools you need to learn about the process, budget for your home, and anonymously shop for mortgages. Our platform is <b>free</b> for home buyers to request quotes. We only make money when your mortgage closes.',
      },
    },
    position: {
      founder: 'Founder and CEO',
      sales: 'Head of Sales',
      advisor: 'Advisor',
    },
    videoTitle: 'Bundle: How it Works',
  },
  RealEstateAgentDashboard: {
    header: 'Connect Your Buyers',
    MyCustomLinkForm: {
      header: 'Custom Referral Link',
      copy: 'Copy',
    },
    addLoanOfficers: 'Add Loan Officer',
    FavoriteLoanOfficersList: {
      noLoanOfficers: 'There are no Favorite Loan Officers',
      LoanOfficerCard: {
        nmls: 'NMLS #',
        branchLocation: 'Branch Location',
      },
    },
  },
  RealEstateAgentLoanOfficers: {
    myLoanOfficers: 'My Loan Officers',
    Search: {
      header: 'Search',
      name: 'Name',
      company: 'Company',
      location: 'Location',
    },
    WaitlistLoanOfficersList: {
      noLoanOfficers: 'Loan Officers not found',
      selectedRows: 'Selected rows:',
      approveAll: 'Approve Selected',
      LoanOfficerCard: {
        branchLocation: 'Location',
        approve: 'Approve',
        apr: 'APR: <b>{{apr}}</b>',
        responseTime: 'Response time: <b>{{responseTime}} min</b>',
      },
    },
    LoanOfficersList: {
      noLoanOfficers: 'There are no Loan Officers',
      LoanOfficerCard: {
        apr: 'APR',
        responseTimeLabel: 'Response Time',
        responseTime: '{{responseTime}} min',
        branchLocation: 'Branch Location',
        add: 'Add',
        favorite: 'Favorite',
      },
    },
    Tabs: {
      allTab: 'All Loan Officers',
      waitlistTab: 'Waitlist',
    },
    FavoriteLoanOfficersList: {
      noLoanOfficers: 'There are no Favorite Loan Officers',
      LoanOfficerCard: {
        nmls: 'NMLS #',
        branchLocation: 'Branch Location',
      },
    },
  },
  RealEstateAgentSettingsPage: {
    header: 'Settings',
    needConfirmation: 'Your Email <b>{{email}}</b> needs to be confirmed, please check your inbox',
    resendConfirmationButton: 'Resend',
    emailSuccessfullySent: 'Email successfully sent',
    changesSaved: 'Changes saved',
    passwordUpdated: 'Password successfully updated',
    UpdatePasswordForm: {
      button: 'Reset Password',
      fields: {
        currentPassword: 'Current Password',
        newPassword: 'New Password',
        passwordConfirmation: 'Retype Password',
      },
    },
    ProfileForm: {
      email: 'Email',
      firstName: 'First Name',
      lastName: 'Last Name',
      mls: 'License #',
      aboutMe: 'About Me',
      phoneNumber: 'Phone Number',
      submitButton: 'Save',
      company: 'Company Name',
      userImage: 'User image',
      companyLogoLabel: 'CompanyLogo',
      CompanyLogo: {
        uploadCompanyLogo: 'Upload',
        changeCompanyLogo: 'Change',
        logo: 'Logo',
      },
      Avatar: {
        changeAvatar: 'Change',
      },
      address: 'Address',
      city: 'City',
      streetAddress: 'Street address',
      state: 'State',
      zipCode: 'Zip Code',
    },
  },
  LoanOfficerDashboard: {
    header: 'Loan Officer Dashboard',
    connections: 'Connections',
    responseTime: 'Response Time',
    licensedStates: 'Enabled/Licensed States',
    comingSoon: 'coming soon!',
    aprTotal: 'APR · Total',
    apr30: 'APR · 30 Years',
    apr15: 'APR · 15 Years',
  },
  LoanOfficerSettings: {
    header: 'Account Settings',
    navTabs: {
      subscriptions: 'Subscriptions',
      profile: 'Profile',
      licensedStates: 'Licensed States',
      resetPassword: 'Reset Password',
      autoFollowupsMessages: 'Auto Followups Messages',
    },
    title: {
      resetPassword: 'Reset Password',
      profile: 'Your Information',
      licensedStates: 'Licensed States',
    },
    AutoFollowupsMessages: {
      title: 'Auto Followups',
      switchTitle: 'Auto followups messages',
      AutoFollowupsMessagesForm: {
        firstMessage: 'First message',
        secondMessage: 'Second message',
        thirdMessage: 'Third message',
        saveButton: 'Save changes',
      },
    },
    ResetPasswordForm: {
      fields: {
        currentPassword: {
          label: 'Current Password',
          placeholder: 'Enter your current password',
        },
        newPassword: {
          label: 'New Password',
          placeholder: 'Enter your new password',
        },
        passwordConfirmation: {
          label: 'Retype Password',
          placeholder: 'Enter your new password  again',
        },
      },
      buttons: {
        save: 'Save',
        cancel: 'Cancel',
      },
      alert: {
        success: 'Password Reset Successful',
      },
    },
  },
  ProfileForm: {
    accountStatus: {
      verified: 'Your account has been <b>approved</b>. Thanks!',
      unverified: {
        first: 'Your account has not yet been approved, the current status is',
        second: 'You can resend the approval request by clicking the Resend button',
      },
      rejected: {
        first: 'Your Account has been rejected, the reason is',
        second: 'You can modify your settings and save them before resending the approval request',
      },
      button: 'Resend',
    },
    fields: {
      firstName: 'First Name',
      lastName: 'Last Name',
      phoneNumber: 'Phone Number',
      email: 'Email',
      applicationUrl: 'Online Application URL',
      video: 'Profile Video',
      nmls: 'NMLS #',
      mortgageCompany: 'Mortgage Company Name',
      companyLogo: 'Mortgage Company Logo',
      companyNmls: 'Mortgage Company NMLS #',
      stateLicenseNumber: 'State License Number',
      mortgageBidDisclosure: 'Mortgage Bid Disclosure',
      aboutMe: 'About Me',
      address: 'Branch Address',
      streetAddress: 'Street Address',
      city: 'City',
      state: 'State',
      zipCode: 'Zip Code',
      keepUpdated: 'Bundle Updates',
      offerings: 'I Offer These Products',
    },
    buttons: {
      changeAvatar: 'Change Image',
      removeAvatar: 'Remove Image',
      saveChanges: 'Save My Account Settings',
      revert: 'Revert',
      uploadCompanyLogo: 'Upload Logo',
      changeCompanyLogo: 'Change Logo',
      uploadVideo: 'Upload Video',
      changeVideo: 'Change Video',
    },
    checkboxAgreeText:
      'Send me updates on items that need my attention like customer questions, customer meeting requests, real estate agent updates, or account notifications',
    checkboxDisagreeText: `Don't ever email me. I'll log in if I want to see progress.`,
    updatesText: 'How would you like to receive updates from Bundle?',
  },
  LicensedStatesForm: {
    buttons: {
      save: 'Save',
      cancel: 'Cancel',
    },
    controls: {
      selectAll: 'Select All',
    },
  },
  Quiz: {
    BuyerRegistration: {
      header: 'Create an account to continue',
    },
    SummaryPage: {
      SavingsSituation: {
        label: 'Savings Situation',
        before: 'before home purchase',
        equity: 'equity in current house',
        available: 'available for new house',
        downPayment: 'down payment',
        closingCosts: 'closing costs',
        after: 'after home purchase',
        monthsSavings: "after you buy your home, you'll have {{months}} months of your income left in savings.",
      },
      MonthlyBudget: {
        label: 'Monthly Budget',
        income: 'income (pre-tax)',
        taxes: 'taxes',
        savings: 'savings',
        loanPayments: 'loan payments',
        otherExpenses: 'other expenses*',
        otherExpensesExplainHeader: '*other expenses is everything else:',
        otherExpensesExplainContent: 'food, fun, clothes, child care, healthcare, insurance',
      },
      MainSummaryBar: {
        homePrice: 'Home Price',
        downPayment: 'Down Payment',
        mortgageLoan: 'Mortgage Loan',
        annualIncomeTimes: 'times your annual income',
        tip: 'TIP: add these up to get home price',
      },
      MortgagePayment: {
        label: 'Mortgage Payment',
        breakdown: 'This is the breakdown:',
        principal: 'principal & interest',
        taxes: 'property taxes',
        mortgageInsurance: 'mortgage insurance',
        hazardInsurance: 'hazard insurance',
      },
      LoansPayment: {
        label: 'Loan Payments',
        breakdown: 'This is the breakdown:',
        carPayment: 'car',
        mortgagePayment: 'mortgage',
        studentLoanPayment: 'student loans',
        creditCardPayment: 'credit cards',
        othelLoansPayment: 'other loans',
      },
      loanPayments: 'Loan Payments',
      monthlyBudget: 'Monthly Budget',
      savingsSituation: 'Savings Situation',
      header: "Congrats! Here's your detailed home price budget.",
      report: 'Home Price Report',
      back: 'Back',
      startOver: 'Start Over',
      save: 'Save My Info',
      compare: 'Mortgage Rates',
    },
    DesktopQuiz: {
      quiz: 'Home Price Budget',
      nextQuestion: 'Next question',
      finish: 'Finish',
    },
    MobileQuiz: {
      next: 'Next',
      previous: 'Previous',
      finish: 'Finish',
      quiz: 'Home Price Budget',
    },
    IntermediateResults: {
      mortgagePayment: 'Mortgage Payment',
      downPayment: 'Down Payment',
      homePrice: 'Home Price',
    },
    MortgageBalanceQuestion: {
      equity: 'Equity',
      agentFees: 'Agent Fees (6%)',
      adjusted: 'Adjusted',
    },
    MortgagePaymentQuestion: {
      suggested: 'Suggested',
      stretched: 'Stretched',
      aggressive: 'Aggressive',
      mortgagePayment: 'Mortgage Payment',
      debtToIncome: 'Debt To Income',
    },
    SavingsMinimumQuestion: {
      suggested: 'Suggested',
      stretched: 'Stretched',
      aggressive: 'Aggressive',
      savings: 'Savings',
      months: 'Months',
    },
  },
  BuyerSettings: {
    header: 'Account Settings',
  },
  OptionalInfoForm: {
    title: 'Optional Information',
    firstText:
      'Bundle never shares your contact information. Your personal information is only used to manage your account.',
    secondText: 'How would you like to get updates from Bundle?',
    checkboxAgreeText: 'Email me updates on my progress, mortgage quotes, and loan officer responses.',
    checkboxDisagreeText: 'Don’t ever email me. I’ll log in if I want to see progress.',
    button: 'Save Changes',
    fields: {
      email: 'E-mail',
      firstName: 'First Name',
      lastName: 'Last Name',
      phoneNumber: 'Phone Number',
    },
  },
  UpdatePasswordForm: {
    title: 'Update Your Password',
    text: 'Bundle does NOT share your information without your consent. Your anonymity is our focus.',
    button: 'Reset Password',
    fields: {
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      passwordConfirmation: 'Retype Password',
    },
    alert: {
      success: 'Password Update Successful',
    },
  },
  MobileNonAuthHeader: {
    SideBar: {
      howItWorks: 'How It Works',
      calculators: 'Calculators',
      quiz: 'Home Price Budget',
      logIn: 'Log In',
      getStarted: 'Get Started',
      scheduleDemo: 'Schedule Demo',
      compare: 'Mortgage Rates',
      mortgageCalculators: 'Mortgage Calculator',
      basics: 'Learn the Basics',
      realEstateAgent: 'I’m a Real Estate Agent',
      loanOfficer: 'I’m a Loan Officer',
      buyer: 'I’m a Buyer',
    },
  },
  NonAuthHomePage: {
    Header: {
      Navigation: {
        howItWorks: 'How It Works',
        calculators: 'Calculators',
        budget: 'Home Price Budget',
        logIn: 'Log In',
        getStarted: 'Get Started',
        scheduleDemo: 'Schedule Demo',
      },
    },
    Banner: {
      root: {
        title: 'Finally, A Modern <br />  Mortgage Company',
        subtitle: 'Great Rates. Simple Process.',
        buttonText: 'Get Started',
      },
      loanOfficerRoot: {
        title: 'Get Matched with<br /> Mortgage Leads',
        subtitle: 'All-in-one platform.<br /> No cold calling.',
        buttonText: 'Schedule Demo',
      },
      realEstateAgentRoot: {
        title: 'Refer Buyers to Your<br /> Trusted Loan Officers',
        subtitle: 'Protect the privacy of your homebuyers.<br /> Faster referrals to your loan officers.',
        buttonText: 'Schedule Demo',
      },
    },
    Description: {
      title: 'How it works',
      root: {
        sections: {
          first: {
            link: 'Request Quotes',
            title: 'Request Quotes',
            description:
              "Build your free profile in a few minutes and we'll match you with the best mortgage. We care about your privacy and never share your contact info.",
          },
          second: {
            link: 'Message & Compare',
            title: 'Message & Compare',
            description: 'Review your quote and chat live to ask questions.',
          },
          third: {
            link: 'Apply',
            title: 'Apply',
            description:
              "Whether it's a pre-approval or a refinance, you'll be ready<br /> to go in minutes with our fully-digital mortgage process. ",
          },
        },
      },
      loanOfficerRoot: {
        sections: {
          first: {
            link: 'Nurture',
            title: 'Bundle Nurtures',
            description:
              'Potential borrowers find Bundle through online<br /> resources. Bundle nurtures borrowers until they<br /> request personalized quotes. Advanced algorithms<br /> match you with active borrowers.',
          },
          second: {
            link: 'Message',
            title: 'Message with Live Borrowers',
            description:
              'You never have to pick up the phone.<br />Chat live with borrowers in real-time.<br /> Send personalized quotes, messages, and videos<br />in one platform. No integrations necessary.',
          },
          third: {
            link: 'Apply',
            title: 'Immediate Applications',
            description:
              'With one click, borrowers are immediately<br /> directed to your online 1003. Start getting<br /> more applications without ever calling!',
          },
        },
      },
      realEstateAgentRoot: {
        sections: {
          first: {
            link: 'Education',
            title: 'Education. Not spam.',
            description:
              'Homebuyers want to use online tools,<br />but don’t want the annoying spam calls.<br />In seconds your homebuyers can connect with your<br />preferred loan officers on a privacy-focused site.',
          },
          second: {
            link: 'Trust',
            title: 'Your Trusted Loan Officers',
            description:
              'You designate which of your trusted<br /> loan officers that buyers can message.<br /> Your custom URL will automatically refer<br /> buyers based on your preferences.',
          },
          third: {
            link: 'Immediate',
            title: 'Immediate Applications',
            description:
              'Within minutes, homebuyers can start their<br /> online application with one of your loan officers.<br /> No more back-and-forth via email, Bundle makes<br /> it easy to start the home buying process online.',
          },
        },
      },
    },
  },
  Footer: {
    contactUs: 'Contact Us',
    bundleCommitment: 'Bundle Commitment',
    navTitle: 'Additional Links',
    navLinks: {
      aboutUs: 'About Us',
      blog: 'Blog',
      faq: 'FAQ',
      loanOfficer: "I'm a Loan Officer",
      realEstateAgent: "I'm a Real Estate Agent",
      privacy: 'Privacy Policy',
      terms: 'Terms and Conditions',
    },
    address: '615 South College Street 9th Floor,<br /> Charlotte, NC 28202',
    description:
      'Bundle is committed to preserving your privacy. Bundle Marketplace Inc. (NMLS# 1927373) supports equal housing opportunity.',
    description2:
      'Bundle Marketplace Inc. (NMLS# 1927373) supports equal housing opportunity. Mortgage rates are based on a $625,000 home purchase in Charlotte, NC with a 20% down payment and excellent credit.',
    copyright: '© {{currentYear}} bundleloan.com',
  },
  SubscriptionPage: {
    title: 'Subscriptions',
    SubscriptionInfo: {
      header: 'Subscription Information',
      saveButton: 'Add Credit Card',
    },
    CreditCardModal: {
      saveButton: 'Save',
      header: 'Add Credit Card',
      cardNumber: 'CARD NUMBER',
      cardName: 'NAME',
      cardExpiry: 'MM/YY',
      cardCvc: 'CVC',
    },
    Budget: {
      header: 'Budget',
      description:
        "Weekly and daily budgets limit the number of connections you can receive. If your daily max is 4 connections, your connections will be temporarily paused if you've had 4 connections in the past 24 hours.",
      weeklyMaxConnections: 'Weekly Max Connections',
      dailyMaxConnections: 'Daily Max Connections',
    },
    UpcomingInvoice: {
      header: 'Upcoming Invoice',
      charge: 'Your Upcoming Invoice',
      willBeCharged: 'You’ll be charged on',
      planTitle: 'Plan',
      basePlan: 'Base plan',
      invoice: 'Invoice',
      connections: 'Connections',
    },
    Connections: {
      header: 'Manage Connections',
      stopAllConnections: 'Pause all states',
      enable: 'Enable',
      disable: 'Disable',
    },
    PaymentMethod: {
      header: 'Payment Method',
      description: 'Add a payment method to get started.',
      updateButton: 'Update Credit Card',
    },
  },
  Switch: {
    on: 'On',
    off: 'Off',
  },
  AdminDashboard: {
    header: 'Loan Officer Pending Approval',
    Search: {
      searchBy: 'Search By',
      searchDescription: 'You may search any or all options bellow at once',
      loanOfficerNameFieldPlaceholder: 'Name',
      companyFieldPlaceholder: 'Company name',
      companyNmlsFieldPlaceholder: 'Company NMLS',
    },
    LoanOfficersList: {
      noLoanOfficers: 'There are no loan officers',
      LoanOfficerCard: {
        company: 'Company:',
        companyNmls: 'Company NMLS:',
        nmls: 'NMLS:',
        email: 'Email:',
      },
    },
  },
  AdministratorLoanOfficer: {
    header: 'Loan Officer Information',
    approve: 'Approve',
    back: 'Back to dashboard',
    LoanOfficerForm: {
      email: 'Email',
      loanOfficerName: 'Full Name',
      nmls: 'NMLS',
      profileImage: 'Profile Image',
      companyLogo: 'Company Logo',
      mortgageCompanyNmls: 'Mortgage Company NMLS',
      company: 'Company',
      bundleCompanyName: 'Bundle Company Name',
      companyEmailExtension: 'Company Email Extension',
      button: 'Save changes',
    },
  },
  EmailConfirmation: {
    success: {
      title: 'Email confirmed successfully!',
      text: 'Thanks for confirming your email <b>{{email}}</b>.<br/> Please login again to continue using Bundle.',
    },
    error: {
      title: 'Email confirmation Error!',
      text:
        'There was a problem confirming your email <b>{{email}}</b>.<br/> Please try again or contact us if the problem persists.',
    },
    login: 'Log In',
  },
  ReferralRealEstateAgent: {
    notFound: "Can't find Real Estate Agent",
    goBack: 'Go Back',
    Guide: {
      firstStepTitle: 'Budget',
      firstStepDescription: 'Complete an easy home price budget',
      secondStepTitle: 'Request Quotes',
      secondStepDescription: "Compare custom mortgage quotes from {{agentFirstName}}'s favorite loan officers",
      thirdStepTitle: 'Get Approved',
      thirdStepDescription: "Click the apply button when you've decided on your lender",
      description: 'Take the next step in your homebuying journey. Compare {{agentFirstName}}’s favorite lenders.',
      button: 'Get Started!',
    },
    FavoriteLoanOfficersList: {
      noLoanOfficers: 'There are no Loan Officers',
      header: `{{- possessiveName}} Mortgage Lenders`,
      LoanOfficerCard: {
        nmls: 'NMLS #',
        branchLocation: 'Branch Location',
      },
    },
    TopBar: {
      button: 'Get Started!',
    },
    BuyerRegistration: {
      buttonLabel: 'Get Started!',
    },
  },
  BuyerLoanOfficerSearchSurvey: {
    LocationSelect: {
      getStarted: 'Get Started',
      title: 'Find a local mortgage<br/>loan officer',
      subtitle: 'Compare personalized offers.<br/>No spam calls.',
    },
    LoanOfficerSelect: {
      header: 'Choose a Loan Officer',
      selectLocation: 'Plese select location',
      LoanOfficerProfileReviewPopup: {
        videoHeader: 'Welcome Video',
        infoHeader: 'Loan Officer Profile',
        button: 'Request Custom Quote',
      },
      LoanOfficersList: {
        emptyLoanOfficers: 'There are no Loan Officers matching your request',
        LoanOfficerCard: {
          branchLocation: 'Branch Location',
          nmls: 'NMLS: {{nmls}}',
          helpedBadgeText: 'helped <b>{{helpedCount}}</b> homebuyers recently',
          fastResponder: 'fast responder',
          lowRates: 'low rates',
          fastClosing: 'fast closing',
        },
      },
    },
    SurveyPage: {
      Survey: {
        header: 'Congrats!',
        description: "Let's get {{name}} some more info...",
        additionalDescription: 'You’re minutes away from messaging loan officer anonymously',
      },
    },
  },
  LoanOfficerRealEstateAgents: {
    header: 'Real Estate Agents',
    Tabs: {
      allTab: 'All',
      waitlistTab: 'Waitlist',
      favoritesTab: 'Favorites',
    },
    RealEstateAgentsList: {
      emptyRealEstateAgents: 'Real Estate Agents not found',
      RealEstateAgentCard: {
        company: 'Company',
        ActionComponent: {
          inFavorites: 'In Favorites',
          inWaitlist: 'In Waitlist',
          button: 'Join waitlist',
        },
      },
    },
    Search: {
      placeholder: 'Start typing name, company',
    },
  },
  NonAuthSurveyPage: {
    Survey: {
      header: 'Great Rates.',
      header2: 'Simple Process.',
      description: 'Finance your dream home with Bundle.',
    },
    BuyerRegistration: {
      or: 'or',
      header: 'We never share your information',
    },
  },
  SurveyPage: {
    Survey: {
      header: 'Compare Mortgage Rates',
      description: 'Connect with lenders. Compare custom quotes with no spam calls.',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en/components.js